import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { SquareButton, type SquareButtonProps } from "mds/components/buttons/SquareButton";
import "./CancelSaveWidget.scss";
import { AmplitudeEventPropertiesType } from "utils/amplitude";

type CancelSaveWidgetProps = {
  className?: string;
  onClickCancel?: () => void;
  onClickSave?: () => void;
  size?: SquareButtonProps["size"];
  isSaveDisabled?: boolean;
  saveTextKey?: "save" | "copy" | "move" | "import_section" | "update";
  saveEventName?: string;
  saveEventProps?: Omit<AmplitudeEventPropertiesType, "eventCategory">;
};

export const CancelSaveWidget: FC<CancelSaveWidgetProps> = ({
  onClickCancel,
  onClickSave,
  className,
  isSaveDisabled = false,
  size = "s",
  saveTextKey = "save",
  saveEventName,
  saveEventProps,
}) => {
  return (
    <div className={twMerge("cancel-save-widget flex self-center", className)}>
      {onClickCancel && (
        <SquareButton
          className="cancel"
          kind="tertiary"
          size={size}
          title={t("common.cancel")}
          onClick={onClickCancel}
        >
          {t("common.cancel")}
        </SquareButton>
      )}
      {onClickSave && (
        <SquareButton
          className="save"
          disabled={isSaveDisabled}
          eventName={saveEventName}
          eventProps={saveEventProps}
          kind="accent"
          size={size}
          title={t(`common.${saveTextKey}`)}
          onClick={onClickSave}
        >
          {t(`common.${saveTextKey}`)}
        </SquareButton>
      )}
    </div>
  );
};
